import React, { useState, useEffect } from 'react';
import validator from 'validator';
import axios from 'axios';
import { defaultVariables } from '../../../../config/index';
import { connect } from "trim-redux";
import {Alert, Box, Card, Checkbox, FormControlLabel, InputAdornment, MenuItem, Typography} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../../components/elements/LoadingButton";
import { Styles } from '../../../../config/design/styles';
import {useSnackbar} from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import AppCardLoaderFields from "../../../components/loaders/AppCardLoaderFields";
import {useNavigate} from "react-router-dom";
import FieldCounter from "../../../components/elements/fields/FieldCounter";
import SubTitle from "../../../components/elements/SubTitle";
import {useParams} from "react-router";
import {useTranslation} from "react-i18next";
import RayaField from "../../../components/elements/fields/RayaField";
import RichEditor from "../../../components/editor/RichEditor";
import EditableJsonComponent from "../../../components/elements/fields/EditJsonField";
import {
    calcInstallmentPrice,
    calcPrePayPrice,
    calcStockPrice,
    currencySymbol,
    price,
    scrollTop, showExactDate, showSimpleDate, showTableDate
} from "../../../../config/values";
import UploadPrivateFile from "../../fileManager/Components/UploadPrivateFile";
import SystemBankInfo from "../../../components/elements/SystemBankInfo";
import ContractButton from "../../../components/elements/ContractButton";
import Button from "@mui/material/Button";
import {isAdmin} from "../../../../config/Permissions";

const MakeInstallment = (props) => {
    const { classes } = props;
    const navigation = useNavigate();
    const { t } = useTranslation();

    let { id } = useParams();

    const [fields, setFields] = useState({
        description: '',
        status: '',
    });
    const [transactionFile, setTransactionFile] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [confirmed, setConfirmed] = useState(!!id);

    const { enqueueSnackbar } = useSnackbar();
    const loginToken = localStorage.getItem('ACT');
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        await axios.get(`${defaultVariables.url}/installments/get/${id}`,config)
            .then(response => {
                setFields({
                    description: !!response.data.description ? response.data.description : "",
                    status: response.data.status,
                });
                setTransactionFile(response.data.transaction_file)
                setPage(response.data)
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        if(!!id){
            loadData();
            setEditMode(true);
        }else{
            setLoading(false);

        }
        scrollTop();
    }, [id]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };
    const handleInputChange = (fieldName, value) => {
        setFields((prevFields) => ({
            ...prevFields,
            [fieldName]: value,
        }));
    };
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};
        if (!transactionFile) {
            formIsValid = false;
            newErrors.transactionFile = t('pleaseUploadAFile');
        }
        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('description', fields.description);
        data.append('transaction_file', !!transactionFile ? transactionFile.id : '');

        if(!!id){
            data.append('item_id', id);
        }
        if(!!isAdmin()){
            data.append('status', fields.status);
        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            await axios.post(`${defaultVariables.url}/installments/make`, data, config);
            enqueueSnackbar(t('detailsSet'), { variant: 'success' });
            setSubmitLoading(false);
            navigation(`/installments/view-all`);

        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });

        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };

    if (loading) {
        return <AppCardLoaderFields />;
    }
    return (
        <Grid container spacing={2} justify="center" >
            <CssBaseline />
            {
                !!id &&
                <>
                    <Grid item size={12}>
                        <Alert
                            className="mt-20 mb-10"
                            severity={fields.status === "pending" ? "warning" : fields.status === "confirmed" ? "success" : fields.status === "not_paid" ? "info" : "error"}
                        >
                            {
                                fields.status === "confirmed" ?
                                    t('yourInstallmentConfirmed')
                                    :
                                    fields.status === "pending" ?
                                        t('yourInstallmentIsPending')
                                        :
                                        fields.status === "not_paid" ?
                                            t('yourInstallmentNotPaid')
                                            :
                                        t('yourInstallmentIsRejected')
                            }
                        </Alert>
                    </Grid>
                    <Grid item size={12}>
                        <Box className="installment-bg flex-column-lg ">
                            <div className='flex-direction space-between-lg brd-bottom-custom'>
                                <Typography className="font-13">{t('bsNumber')}:</Typography>
                                <Typography className="font-13"> <strong>{page.bs_number}</strong></Typography>
                            </div>
                            <div className='flex-direction space-between-lg brd-bottom-custom' >
                                <Typography className="font-13">{t('due_date')}:</Typography>
                            <Typography className="font-13"><strong>{showSimpleDate(page.due_date)}</strong></Typography>
                        </div>

                            {
                                !!page.confirmation_date &&
                                <div className='flex-direction space-between-lg brd-bottom-custom'>
                                    <Typography className="font-13">{t('confirmation_date')}:</Typography>
                                    <Typography className="font-13"><strong>{showTableDate(page.confirmation_date)}</strong></Typography>
                                </div>

                            }
                            <div className='flex-direction space-between-lg'>
                                <Typography className="font-13" >{t('price')}:</Typography>
                                <Typography className="font-13" ><strong>{price(page.price)} {currencySymbol}</strong></Typography>
                            </div>

                        </Box>

                    </Grid>
                </>

            }
            <Grid item size={{xs:12,md:12}} className="bg-gray-box pt-30">
                <Grid container spacing={2} justify="center">
                    <Grid item size={12}>
                        <SystemBankInfo/>
                    </Grid>
                    <Grid item size={12}>
                        <SubTitle align="left">{t('submitTransactionFile')}</SubTitle>
                        <UploadPrivateFile
                            title={t('uploadTransactionFile')}
                            setFile={(file) => setTransactionFile(file)}
                            init={transactionFile}
                        />
                        {
                            !!errors['transactionFile'] &&
                            <Typography className="error-text">{errors['transactionFile']}</Typography>
                        }
                    </Grid>
                    <Grid item size={{xs:12}}>
                        <RayaField
                            variant="outlined"
                            required
                            fullWidth
                            label={t('description')}
                            name="description"
                            value={fields.description}
                            onChange={handleChange}
                            error={!!errors.description}
                            helperText={errors.description}
                            multiline
                        />
                    </Grid>
                    {
                        !!isAdmin() &&
                        <Grid item size={{xs:12,md:6}}>
                            <RayaField
                                variant="outlined"
                                required
                                fullWidth
                                label={t('status')}
                                name="status"
                                value={fields.status}
                                onChange={handleChange}
                                error={!!errors.status}
                                helperText={errors.status}
                                select
                            >
                                <MenuItem value='rejected'>{t('rejected')}</MenuItem>
                                <MenuItem value='not_paid'>{t('not_paid')}</MenuItem>
                                <MenuItem value='pending'>{t('pending')}</MenuItem>
                                <MenuItem value='confirmed'>{t('confirmed')}</MenuItem>
                            </RayaField>
                        </Grid>
                    }
                    <Grid item size={12}>
                        <LoadingButton
                            variant="contained"
                            color="secondary"
                            onClick={handleSubmit}
                            loading={submitLoading}
                        >
                            {t('save')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(MakeInstallment));
